import { useState } from "react";
import styled from "styled-components";
import { IoIosArrowDown } from "react-icons/io";


const DiscountDropdown = ({ bulkDiscounts }) => {
    const [isOpen, setIsOpen] = useState(false);

    const sortedDiscounts = [...bulkDiscounts].sort((a, b) => a.quantity - b.quantity);

    return (
        <DropdownContainer>
            <DropdownButton onClick={() => setIsOpen(!isOpen)}>
                {sortedDiscounts[0].quantity} for {sortedDiscounts[0].price} NOK
                <IoIosArrowDown />
            </DropdownButton>

            {isOpen && (
                <DropdownList>
                    {sortedDiscounts.map((discount, index) => (
                        <DropdownItem key={index}>
                            {discount.quantity} for {discount.price} NOK
                        </DropdownItem>
                    ))}
                </DropdownList>
            )}
        </DropdownContainer>
    );
};

export default DiscountDropdown;

const DropdownContainer = styled.div`
    position: relative;
    display: inline-block;
    width: 100%;
    text-align: center;
    margin-bottom: 12px;
`;

const DropdownButton = styled.div`
    background: none;
    color: #2d6a4f;
    font-size: 1rem;
    font-weight: bold;
    padding: 6px 12px;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    user-select: none;
    transition: background 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    
    &:hover {
        background: #1b4332;
        color: #fff;
    }
`;

const DropdownList = styled.div`
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    border: 1px solid #ccc;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    min-width: 150px;
    overflow: hidden;
    z-index: 10;
    width: 100%;
`;

const DropdownItem = styled.div`
    padding: 8px 12px;
    font-size: 0.9rem;
    color: #333;
    cursor: pointer;
    transition: background 0.2s ease-in-out;

    &:hover {
        background: #f5f5f5;
    }
`;
